import { render, staticRenderFns } from "./formSocialServe.vue?vue&type=template&id=6167b531&scoped=true&"
import script from "./formSocialServe.vue?vue&type=script&lang=js&"
export * from "./formSocialServe.vue?vue&type=script&lang=js&"
import style0 from "./formSocialServe.vue?vue&type=style&index=0&id=6167b531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6167b531",
  null
  
)

export default component.exports